import * as React from "react";
import { Component } from "react";
import { Form } from "react-bootstrap";
import ServiceCharges from "../ServiceCharges";
import StatementSummary from "../StatementSummary";
import CarryForwardCredits from "./CarryForwardCredits";
import ElectricityCredited from "./ElectricityCredited";
import ElectricityFromGrid from "./ElectricityFromGrid";
import { IAdvancedSingleRateStatementProps, IAdvancedSingleRateStatementState } from "./interfaces";
import NetElectricity from "./NetElectricity";
import SolarGenerated from "./SolarGenerated";

export default class AdvancedSingleRateStatement extends Component<
  IAdvancedSingleRateStatementProps,
  IAdvancedSingleRateStatementState
> {
  public constructor(props: IAdvancedSingleRateStatementProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleGridReadDateChanged = this.handleGridReadDateChanged.bind(this);
    this.handleGridReadingChanged = this.handleGridReadingChanged.bind(this);
    this.handlePriorGridReadDateChanged = this.handlePriorGridReadDateChanged.bind(this);
    this.handlePriorGridReadingChanged = this.handlePriorGridReadingChanged.bind(this);

    this.handleSolarReadDateChanged = this.handleSolarReadDateChanged.bind(this);
    this.handleSolarReadingChanged = this.handleSolarReadingChanged.bind(this);
    this.handlePriorSolarReadDateChanged = this.handlePriorSolarReadDateChanged.bind(this);
    this.handlePriorSolarReadingChanged = this.handlePriorSolarReadingChanged.bind(this);

    this.handleSolarGeneratedChanged = this.handleSolarGeneratedChanged.bind(this);
    this.handleNetElectricityChanged = this.handleNetElectricityChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    const gridUsage = this.props.gridReading - this.props.priorGridReading;
    const solarReceived = this.props.solarReading - this.props.priorSolarReading;
    let creditBalance = solarReceived + this.props.credits - gridUsage;
    if (creditBalance < 0) {
      creditBalance = 0;
    }
    return (
      <div className="flex">
        <div className="left-column">
          <Form horizontal={true}>
            <StatementSummary
              appService={this.props.appService}
              match={this.props.match}
              serviceStartDate={this.props.serviceStartDate}
              serviceEndDate={this.props.serviceEndDate}
              serviceStartDateChanged={this.props.serviceStartDateChanged}
              serviceEndDateChanged={this.props.serviceEndDateChanged}
              statementDate={this.props.statementDate}
              yearsWithSolar={this.props.yearsWithSolar}
              totalAmountDue={this.props.totalAmountDue}
              statementDateChanged={this.props.statementDateChanged}
              yearsWithSolarChanged={this.props.yearsWithSolarChanged}
              totalAmountDueChanged={this.props.totalAmountDueChanged}
              showNetElectricityCredit={false}
              netElectricityCredit={NaN}
              netElectricityCreditChanged={this.handleNetElectricityChanged}
            />
            <ElectricityFromGrid
              appService={this.props.appService}
              match={this.props.match}
              history={this.props.history}
              gridReadDate={this.props.gridReadDate}
              gridReading={this.props.gridReading}
              priorGridReadDate={this.props.priorGridReadDate}
              priorGridReading={this.props.priorGridReading}
              gridReadDateChanged={this.handleGridReadDateChanged}
              gridReadingChanged={this.handleGridReadingChanged}
              priorGridReadDateChanged={this.handlePriorGridReadDateChanged}
              priorGridReadingChanged={this.handlePriorGridReadingChanged}
              priorDataEditable={this.props.priorDataEditable}
            />
            <ElectricityCredited
              appService={this.props.appService}
              match={this.props.match}
              history={this.props.history}
              solarReadDate={this.props.solarReadDate}
              solarReading={this.props.solarReading}
              priorSolarReadDate={this.props.priorSolarReadDate}
              priorSolarReading={this.props.priorSolarReading}
              solarReadDateChanged={this.handleSolarReadDateChanged}
              solarReadingChanged={this.handleSolarReadingChanged}
              priorSolarReadDateChanged={this.handlePriorSolarReadDateChanged}
              priorSolarReadingChanged={this.handlePriorSolarReadingChanged}
              priorDataEditable={this.props.priorDataEditable}
            />
          </Form>
        </div>
        <div className="right-column">
          <Form horizontal={true}>
            <SolarGenerated
              appService={this.props.appService}
              solarGenerated={this.props.solarGenerated}
              solarReceived={solarReceived}
              solarGeneratedChanged={this.handleSolarGeneratedChanged}
            />
            <NetElectricity
              appService={this.props.appService}
              gridUsage={gridUsage}
              solarReceived={solarReceived}
            />
            <CarryForwardCredits
              appService={this.props.appService}
              solarReceived={solarReceived}
              gridUsage={gridUsage}
              credits={this.props.credits}
              creditBalance={creditBalance}
            />
          </Form>
        </div>
        <div className="left-right-column">
          <ServiceCharges
            title="Service Charges"
            serviceCharges={this.props.serviceCharges}
            addServiceCharge={this.props.addServiceCharge}
            deleteServiceCharge={this.props.deleteServiceCharge}
            updateServiceCharge={this.props.updateServiceCharge}
            copyPriorServiceCharges={this.props.copyPriorServiceCharges}
            needsSaving={this.props.needsSaving}
            match={this.props.match}
          />
        </div>
        <div />
      </div>
    );
  }

  private handleGridReadDateChanged(e: any) {
    this.props.gridReadDateChanged(e);
  }
  private handleGridReadingChanged(e: any) {
    this.props.gridReadingChanged(e);
  }
  private handlePriorGridReadDateChanged(e: any) {
    this.props.priorGridReadDateChanged(e);
  }
  private handlePriorGridReadingChanged(e: any) {
    this.props.priorGridReadingChanged(e);
  }

  private handleSolarReadDateChanged(e: any) {
    this.props.solarReadDateChanged(e);
  }
  private handleSolarReadingChanged(e: any) {
    this.props.solarReadingChanged(e);
  }
  private handlePriorSolarReadDateChanged(e: any) {
    this.props.priorSolarReadDateChanged(e);
  }
  private handlePriorSolarReadingChanged(e: any) {
    this.props.priorSolarReadingChanged(e);
  }

  private handleSolarGeneratedChanged(e: any) {
    this.props.solarGeneratedChanged(e);
  }

  private handleNetElectricityChanged(e: any) {
    return;
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/AdvancedSingleRateStatement.tsx